import globalAxios from 'axios';
import { B as BaseAPI, D as DUMMY_BASE_URL, s as setBearerAuthToObject, b as setSearchParams, c as serializeDataIfNeeded, t as toPathString, a as assertParamExists, o as operationServerMap, d as createRequestFunction, e as BASE_PATH } from '../common-BuhUSHAi.js';

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * ProductFiltersApi - axios parameter creator
 * @export
 */
const ProductFiltersApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll: async (options = {}) => {
            const localVarPath = `/v1/ProductFilters/GetAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById: async (id, options = {}) => {
            const localVarPath = `/v1/ProductFilters/GetById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {Array<number>} [request_body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByIds: async (request_body, options = {}) => {
            const localVarPath = `/v1/ProductFilters/GetByIds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(request_body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {ProductFilterToken} [ProductFilterToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insert: async (ProductFilterToken, options = {}) => {
            const localVarPath = `/v1/ProductFilters/Insert`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ProductFilterToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {string} [term]
         * @param {number} [top]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookup: async (term, top, options = {}) => {
            const localVarPath = `/v1/ProductFilters/Lookup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }
            if (top !== undefined) {
                localVarQueryParameter['top'] = top;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('remove', 'id', id);
            const localVarPath = `/v1/ProductFilters/Remove/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Populates a manual-run filter (BizWeb.NC.Data.Domain.Catalog.ProductFilter.ShouldRunManually) and applies its assignments. (Auth roles: Catalog)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runManually: async (id, options = {}) => {
            const localVarPath = `/v1/ProductFilters/RunManually`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Sets the assignments (attributes/statuses given to the products matching the filter) and applies them. (Auth roles: Catalog)
         * @param {ProductFilterToken} [ProductFilterToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAssignments: async (ProductFilterToken, options = {}) => {
            const localVarPath = `/v1/ProductFilters/SetAssignments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ProductFilterToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {ProductFilterToken} [ProductFilterToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setFilter: async (ProductFilterToken, options = {}) => {
            const localVarPath = `/v1/ProductFilters/SetFilter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ProductFilterToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {ProductFilterToken} [ProductFilterToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (ProductFilterToken, options = {}) => {
            const localVarPath = `/v1/ProductFilters/Update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ProductFilterToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ProductFiltersApi - functional programming interface
 * @export
 */
const ProductFiltersApiFp = function (configuration) {
    const localVarAxiosParamCreator = ProductFiltersApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAll(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductFiltersApi.getAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getById(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductFiltersApi.getById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {Array<number>} [request_body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByIds(request_body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByIds(request_body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductFiltersApi.getByIds']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {ProductFilterToken} [ProductFilterToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async insert(ProductFilterToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.insert(ProductFilterToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductFiltersApi.insert']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {string} [term]
         * @param {number} [top]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lookup(term, top, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lookup(term, top, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductFiltersApi.lookup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductFiltersApi.remove']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Populates a manual-run filter (BizWeb.NC.Data.Domain.Catalog.ProductFilter.ShouldRunManually) and applies its assignments. (Auth roles: Catalog)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async runManually(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.runManually(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductFiltersApi.runManually']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Sets the assignments (attributes/statuses given to the products matching the filter) and applies them. (Auth roles: Catalog)
         * @param {ProductFilterToken} [ProductFilterToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setAssignments(ProductFilterToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setAssignments(ProductFilterToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductFiltersApi.setAssignments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {ProductFilterToken} [ProductFilterToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setFilter(ProductFilterToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setFilter(ProductFilterToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductFiltersApi.setFilter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {ProductFilterToken} [ProductFilterToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(ProductFilterToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(ProductFilterToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductFiltersApi.update']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * ProductFiltersApi - factory interface
 * @export
 */
const ProductFiltersApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ProductFiltersApiFp(configuration);
    return {
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll(options) {
            return localVarFp.getAll(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById(id, options) {
            return localVarFp.getById(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {Array<number>} [request_body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByIds(request_body, options) {
            return localVarFp.getByIds(request_body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {ProductFilterToken} [ProductFilterToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insert(ProductFilterToken, options) {
            return localVarFp.insert(ProductFilterToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {string} [term]
         * @param {number} [top]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookup(term, top, options) {
            return localVarFp.lookup(term, top, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id, options) {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Populates a manual-run filter (BizWeb.NC.Data.Domain.Catalog.ProductFilter.ShouldRunManually) and applies its assignments. (Auth roles: Catalog)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runManually(id, options) {
            return localVarFp.runManually(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Sets the assignments (attributes/statuses given to the products matching the filter) and applies them. (Auth roles: Catalog)
         * @param {ProductFilterToken} [ProductFilterToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAssignments(ProductFilterToken, options) {
            return localVarFp.setAssignments(ProductFilterToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {ProductFilterToken} [ProductFilterToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setFilter(ProductFilterToken, options) {
            return localVarFp.setFilter(ProductFilterToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: Catalog)
         * @param {ProductFilterToken} [ProductFilterToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(ProductFilterToken, options) {
            return localVarFp.update(ProductFilterToken, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ProductFiltersApi - object-oriented interface
 * @export
 * @class ProductFiltersApi
 * @extends {BaseAPI}
 */
class ProductFiltersApi extends BaseAPI {
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductFiltersApi
     */
    getAll(options) {
        return ProductFiltersApiFp(this.configuration).getAll(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductFiltersApi
     */
    getById(id, options) {
        return ProductFiltersApiFp(this.configuration).getById(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {Array<number>} [request_body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductFiltersApi
     */
    getByIds(request_body, options) {
        return ProductFiltersApiFp(this.configuration).getByIds(request_body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {ProductFilterToken} [ProductFilterToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductFiltersApi
     */
    insert(ProductFilterToken, options) {
        return ProductFiltersApiFp(this.configuration).insert(ProductFilterToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {string} [term]
     * @param {number} [top]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductFiltersApi
     */
    lookup(term, top, options) {
        return ProductFiltersApiFp(this.configuration).lookup(term, top, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductFiltersApi
     */
    remove(id, options) {
        return ProductFiltersApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Populates a manual-run filter (BizWeb.NC.Data.Domain.Catalog.ProductFilter.ShouldRunManually) and applies its assignments. (Auth roles: Catalog)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductFiltersApi
     */
    runManually(id, options) {
        return ProductFiltersApiFp(this.configuration).runManually(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Sets the assignments (attributes/statuses given to the products matching the filter) and applies them. (Auth roles: Catalog)
     * @param {ProductFilterToken} [ProductFilterToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductFiltersApi
     */
    setAssignments(ProductFilterToken, options) {
        return ProductFiltersApiFp(this.configuration).setAssignments(ProductFilterToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {ProductFilterToken} [ProductFilterToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductFiltersApi
     */
    setFilter(ProductFilterToken, options) {
        return ProductFiltersApiFp(this.configuration).setFilter(ProductFilterToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: Catalog)
     * @param {ProductFilterToken} [ProductFilterToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductFiltersApi
     */
    update(ProductFilterToken, options) {
        return ProductFiltersApiFp(this.configuration).update(ProductFilterToken, options).then((request) => request(this.axios, this.basePath));
    }
}

export { ProductFiltersApi, ProductFiltersApiAxiosParamCreator, ProductFiltersApiFactory, ProductFiltersApiFp };
//# sourceMappingURL=product-filters-api.js.map
